import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
export default (function (organisationId, userId, role) {
    var obj = {
        'userId': userId,
        'userRole': role.toString(),
        'organisationId': organisationId
    };
    var headers = { 'Content-Type': 'application/json' };
    var url = applyPathVariables(EndPoints.ORGANISATION_USER_ROLE_UPDATE, {
        organisationId: organisationId,
    });
    var request = new Request({
        method: Methods.PUT,
        url: url,
        withCredentials: true,
        headers: headers,
        data: JSON.stringify(obj)
    });
    return request.execute();
});
